import { INTEREST_ITEMS }
  from '../constants/types.js';

export default function(state=[], action){
  switch(action.type){
    case INTEREST_ITEMS:
      return [ ...state, ...action.payload ]
    default:
      return state
  }
}
